// extracted by mini-css-extract-plugin
export default {"container":"NotificattionContainer_container__tP7r4","close":"NotificattionContainer_close__iVnyg"};